import { Route, Routes } from "react-router-dom";
import "./App.css";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./components/Home";
import License from "./components/License";
import NotFound from "./components/NotFound";
import Tool from "./components/Tool";
import Tools from "./components/Tools";
import tools from "./core/tools";
import Privacy from "./components/Privacy";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Parent route for tools */}
        <Route path="/tools">
          <Route index element={<Tools tools={tools} />} />
          {tools.sort((x, y) => x.isDisabled - y.isDisabled).map((_tool, index) => (
            <Route
              key={index}
              path={_tool.link} // Relative path
              element={
                _tool.component ? (
                  <Tool
                    title={_tool.title}
                    description={_tool.description}
                    component={_tool.component}
                  />
                ) : (
                  <NotFound />
                )
              }
            />
          ))}
        </Route>
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/license" element={<License />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<NotFound />} /> {/* 404 fallback */}
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
